<template>
    <form-row :title="user_is_attorney ? 'Have you agreed to and signed the terms of the deal?' : 'Has your attorney agreed to and signed the terms of the deal?'">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-multi
                name="has_signed_deal"
                v-model="has_signed_deal"
                :options="[
                    { label: 'Yes', value: 1, },
                    { label: 'No', value: 0, },
                    { label: 'N/A', value: -1, },
                ]"
                :read_only="read_only"
            />

            <input-date
                v-if="has_signed_deal == 1"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Received:"
                :value="attorney.signed_deal_at"
                name="signed_deal_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
        user_is_attorney: { default: false },
    },

    data() {
        return {
            has_signed_deal: this.attorney.has_signed_deal,
        }
    },
}
</script>
